/*
  Combined course script for Single, Bundle, Curriculum, and Combined products.
  Determines mode from window.learnCourseConfig (product.type or Combined tag)
  and builds the UI accordingly. Listens for variant changes and (re)loads the
  appropriate courses_*.js asset based on window.variantCourseMap.
*/

(function() {
  // ---------------- Configuration ---------------- //
  function determineMode() {
    try {
      var cfg = window.learnCourseConfig || {};
      var productType = (cfg.productType || '').toLowerCase();
      if (productType === 'single course') return 'single';
      if (productType === 'bundle course') return 'bundle';
      if (productType === 'curriculum' || productType === 'state curriculum') return 'curriculum';
      if (productType === 'combined') {
        var tag = (cfg.combinedModeTag || '').toLowerCase();
        if (tag === 'single course') return 'single';
        if (tag === 'bundle course') return 'bundle';
        if (tag === 'curriculum' || tag === 'state curriculum') return 'curriculum';
        // default for Combined if no tag
        return 'curriculum';
      }
    } catch(e) {}
    // Fallback
    return 'single';
  }

  var mode = determineMode();
  var isCombinedProduct = false;
  try {
    var __cfg = window.learnCourseConfig || {};
    isCombinedProduct = ((__cfg.productType || '').toLowerCase() === 'combined');
  } catch(e) {}

  // ---------------- State ---------------- //
  var searchData = [];
  var filters = { search: '', credit_units: [], course_category_id: [], cert_prep: [] };
  var currentIndex = 0;

  // ---------------- Utilities ---------------- //
  function debounce(func, timeout) {
    if (timeout === void 0) { timeout = 300; }
    var timer;
    return function() {
      var args = Array.prototype.slice.call(arguments);
      clearTimeout(timer);
      timer = setTimeout(function() { func.apply(this, args); }, timeout);
    };
  }

  function isMobile() { return window.innerWidth <= 799; }

  function deepClone(obj) { return JSON.parse(JSON.stringify(obj)); }

  function computeSearchDataFromCourses(courses) {
    if (!Array.isArray(courses)) return [];
    if (mode === 'single') {
      return deepClone(courses);
    }
    // bundle/curriculum primary shape: wrapper objects (course_type 32) with sub_courses
    var wrapped = courses
      .filter(function(course) { return course && course.course_type === 32 && Array.isArray(course.sub_courses); })
      .flatMap(function(course) { return course.sub_courses; });

    // If the primary shape produced nothing, fall back to using the array as-is.
    // Some bundles are already a flat list of courses without a wrapper.
    var list = wrapped.length > 0 ? wrapped : courses;

    return list.filter(function(subCourse) {
      return !subCourse.name || !subCourse.name.startsWith('A Guide to');
    });
  }

  function resolveCourseScriptUrl(variantId) {
    var map = window.variantCourseMap || {};
    var val = map[variantId];
    if (!val) return null;
    if (typeof val === 'string' && (val.startsWith('http') || val.startsWith('/'))) {
      return val;
    }
    // If a SKU is provided and a base URL is available, construct from base
    if (typeof val === 'string' && window.coursesAssetBase) {
      try { return window.coursesAssetBase.replace('courses.slimline.min.js', 'courses_' + val + '.js'); } catch(e) {}
    }
    return null;
  }

  // ---------------- Rendering ---------------- //
  function buildTabs(course, index) {
    var tabsHTML = '<div class="tab nomob">';
    if (course.description) { tabsHTML += '<button class="tablinks nomob" aria-controls="angebot-' + index + '-1">Course Overview</button>'; }
    if (course.learning_objectives_html) { tabsHTML += '<button class="tablinks nomob" aria-controls="angebot-' + index + '-2">Learning Objectives</button>'; }
    if (course.author_information) { tabsHTML += '<button class="tablinks nomob" aria-controls="angebot-' + index + '-3">Author Information</button>'; }
    if (course.course_outline_html) { tabsHTML += '<button class="tablinks nomob" aria-controls="angebot-' + index + '-4">Course Outline</button>'; }
    if (course.ce_accreditation && course.ce_accreditation.accrediting_body_name) { tabsHTML += '<button class="tablinks nomob" aria-controls="angebot-' + index + '-5">Credit Info</button>'; }
    tabsHTML += '</div><div class="tabcontents nomob">';

    if (course.description) { tabsHTML += '<div id="angebot-' + index + '-1" class="tabcontent tab1">' + course.description + '</div>'; }
    if (course.learning_objectives_html) { tabsHTML += '<div id="angebot-' + index + '-2" class="tabcontent tab2" style="display: none;">' + course.learning_objectives_html + '</div>'; }
    if (course.author_information) { tabsHTML += '<div id="angebot-' + index + '-3" class="tabcontent tab3" style="display: none;">' + course.author_information + '</div>'; }
    if (course.course_outline_html) { tabsHTML += '<div id="angebot-' + index + '-4" class="tabcontent tab4" style="display: none;">' + course.course_outline_html + '</div>'; }
    if (course.ce_accreditation && course.ce_accreditation.accrediting_body_name) {
      tabsHTML += '<div id="angebot-' + index + '-5" class="tabcontent tab5" style="display: none;">'
        + '<div><strong>Accrediting Body</strong>: ' + course.ce_accreditation.accrediting_body_name + '</div>'
        + (course.ce_accreditation.credit_display_name
            ? '<div><strong>Credit Name</strong>: ' + course.ce_accreditation.credit_display_name + '<br>'
              + '<strong>Credit Units</strong>: ' + course.ce_accreditation.credit_units + ' '
              + (course.ce_accreditation.credit_unit_display_name || '') + '</div>'
            : '')
        + ((course.ce_accreditation.course_level_accreditation_statement || course.ce_accreditation.accreditation_statement)
            ? '<div><strong>Accreditation Statement</strong>:</div>'
              + (course.ce_accreditation.course_level_accreditation_statement ? '<div>' + course.ce_accreditation.course_level_accreditation_statement + '</div>' : '')
              + (course.ce_accreditation.accreditation_statement ? '<div>' + course.ce_accreditation.accreditation_statement + '</div>' : '')
            : '')
        + '</div>';
    }
    tabsHTML += '</div>';

    // Mobile tabs
    tabsHTML += '<div class="tab nodesktop">';
    if (course.description) {
      tabsHTML += '<button type="button" aria-controls="angebot-' + index + '-1" class="tablinks nodesktop">Course Overview <span class="indicator"></span></button>'
                + '<div id="angebot-' + index + '-1" class="tabcontent tab1">' + course.description + '</div>';
    }
    if (course.learning_objectives_html) {
      tabsHTML += '<button type="button" aria-controls="angebot-' + index + '-2" class="tablinks nodesktop">Learning Objectives <span class="indicator"></span></button>'
                + '<div id="angebot-' + index + '-2" class="tabcontent tab2" style="display: none;">' + course.learning_objectives_html + '</div>';
    }
    if (course.author_information) {
      tabsHTML += '<button type="button" aria-controls="angebot-' + index + '-3" class="tablinks nodesktop">Author Information <span class="indicator"></span></button>'
                + '<div id="angebot-' + index + '-3" class="tabcontent tab3" style="display: none;">' + course.author_information + '</div>';
    }
    if (course.course_outline_html) {
      tabsHTML += '<button type="button" aria-controls="angebot-' + index + '-4" class="tablinks nodesktop">Course Outline <span class="indicator"></span></button>'
                + '<div id="angebot-' + index + '-4" class="tabcontent tab4" style="display: none;">' + course.course_outline_html + '</div>';
    }
    if (course.ce_accreditation && course.ce_accreditation.accrediting_body_name) {
      tabsHTML += '<button type="button" aria-controls="angebot-' + index + '-5" class="tablinks nodesktop">Credit Info <span class="indicator"></span></button>'
                + '<div id="angebot-' + index + '-5" class="tabcontent tab5" style="display: none;">'
                + '<div><strong>Accrediting Body</strong>: ' + course.ce_accreditation.accrediting_body_name + '</div>'
                + (course.ce_accreditation.credit_display_name
                    ? '<div><strong>Credit Name</strong>: ' + course.ce_accreditation.credit_display_name + '<br>'
                      + '<strong>Credit Units</strong>: ' + course.ce_accreditation.credit_units + ' '
                      + (course.ce_accreditation.credit_unit_display_name || '') + '</div>'
                    : '')
                + ((course.ce_accreditation.course_level_accreditation_statement || course.ce_accreditation.accreditation_statement)
                    ? '<div><strong>Accreditation Statement</strong>:</div>'
                      + (course.ce_accreditation.course_level_accreditation_statement ? '<div>' + course.ce_accreditation.course_level_accreditation_statement + '</div>' : '')
                      + (course.ce_accreditation.accreditation_statement ? '<div>' + course.ce_accreditation.accreditation_statement + '</div>' : '')
                    : '')
                + '</div>';
    }
    tabsHTML += '</div>';
    return tabsHTML;
  }

  function buildCourseHTML(course, index, openInitially) {
    var isOpen = !!openInitially;
    var showDetailsText = isOpen ? (isMobile() ? 'Close' : 'Hide Details') : 'Show Details';
    var accordionActiveClass = isOpen ? ' active' : '';
    var panelClass = isOpen ? 'panel accordion-visible' : 'panel';
    return (
      '<div class="top-buttons">'
      + '<button class="show-details">' + showDetailsText + '</button>'
      + '<button class="accordion' + accordionActiveClass + '">' + (course.name || '') +
        '<span class="credit-units">' + ((course.ce_accreditation && course.ce_accreditation.credit_units != null)
          ? (course.ce_accreditation.credit_units + ' credit unit(s)')
          : '') + '</span>'
      + '</button>'
      + '</div>'
      + '<div class="' + panelClass + '">' + buildTabs(course, index) + '</div>'
    );
  }

  function buildResult(data) {
    var courseListElement = document.getElementById('courseList');
    if (!courseListElement) return;

    var content = '';
    var initialCount = (mode === 'single') ? data.length : Math.min(20, data.length);
    var defaultOpen = (mode === 'single' && !isCombinedProduct);
    data.slice(0, initialCount).forEach(function(course, index) {
      var fallbackIndex = data.indexOf(course);
      var courseId = 'fallback-' + fallbackIndex;
      content += '<div class="course-item" data-course-id="' + courseId + '">' + buildCourseHTML(course, fallbackIndex, defaultOpen) + '</div>';
    });
    courseListElement.innerHTML = content;

    var titleEl = document.querySelector('h2.title');
    if (titleEl) {
      var count = data.length;
      if (count === 1) {
        titleEl.textContent = 'Course Included';
      } else {
        titleEl.innerHTML = '<span>' + count + '</span> Courses Included';
      }
    }

    initializeTabsForAllItems();
    setInitialButtonText();
    currentIndex = (mode === 'single') ? data.length : initialCount;
    checkMoreCourses();

    // For Combined pages showing a single sub-product, toggle open after render
    if (isCombinedProduct && data.length === 1) {
      try {
        var firstItem = document.querySelector('.course-item');
        if (firstItem) {
          var panel0 = firstItem.querySelector('.panel');
          var accordion0 = firstItem.querySelector('.accordion');
          var showBtn0 = firstItem.querySelector('.show-details');
          if (panel0 && accordion0 && showBtn0 && !panel0.classList.contains('accordion-visible')) {
            toggleAccordion(accordion0, panel0, showBtn0);
          }
        }
      } catch(e) {}
    }
  }

  function loadMoreCourses() {
    var filteredData = searchData;
    var nextIndex = currentIndex + 8;
    if (nextIndex > filteredData.length) nextIndex = filteredData.length;

    var newCourses = filteredData.slice(currentIndex, nextIndex);
    if (newCourses.length === 0) {
      checkMoreCourses();
      return;
    }

    var courseListElement = document.getElementById('courseList');
    newCourses.forEach(function(course) {
      var fallbackIndex = filteredData.indexOf(course);
      var courseId = 'fallback-' + fallbackIndex;
      if (!document.querySelector('[data-course-id="' + courseId + '"]')) {
        var courseItem = document.createElement('div');
        courseItem.classList.add('course-item');
        courseItem.setAttribute('data-course-id', courseId);
        courseItem.innerHTML = buildCourseHTML(course, fallbackIndex, false);
        courseListElement.appendChild(courseItem);
      }
    });
    currentIndex = nextIndex;
    initializeTabsForAllItems();
    setInitialButtonText();
    checkMoreCourses();
  }

  function checkMoreCourses() {
    var btn = document.getElementById('loadMoreCourses');
    if (!btn) return;
    if (mode === 'single') {
      btn.style.display = 'none';
      return;
    }
    var currentItemCount = document.querySelectorAll('.course-item').length;
    btn.style.display = (currentItemCount >= searchData.length) ? 'none' : 'block';
  }

  function toggleAccordion(accordionButton, accordionPanel, showDetailsButton) {
    var isVisible = accordionPanel.classList.contains('accordion-visible');
    accordionPanel.classList.toggle('accordion-visible', !isVisible);
    accordionButton.classList.toggle('active', !isVisible);
    showDetailsButton.textContent = isMobile() ? (isVisible ? 'Details' : 'Close') : (isVisible ? 'Show Details' : 'Hide Details');
  }

  function initializeTabsForAllItems() {
    var courseItems = document.querySelectorAll('.course-item');
    courseItems.forEach(function(courseItem) {
      var useMobile = isMobile();
      var tabContents = useMobile
        ? courseItem.querySelectorAll('.tab.nodesktop .tabcontent')
        : courseItem.querySelectorAll('.tabcontents.nomob .tabcontent');
      var tabLinks = useMobile
        ? courseItem.querySelectorAll('.tab.nodesktop .tablinks')
        : courseItem.querySelectorAll('.tab.nomob .tablinks');

      // Reset both mobile and desktop groups to avoid mismatched states
      courseItem.querySelectorAll('.tabcontent').forEach(function(content) { content.style.display = 'none'; });
      courseItem.querySelectorAll('.tablinks').forEach(function(link) { link.classList.remove('active'); });

      if (tabContents.length) tabContents[0].style.display = 'block';
      if (tabLinks.length) tabLinks[0].classList.add('active');
    });
    adjustTabContentHeight();
  }

  function adjustTabContentHeight() {
    var tabContents = document.querySelectorAll('.tabcontent');
    tabContents.forEach(function(tabContent) {
      if (tabContent.style.display === 'block') {
        tabContent.style.maxHeight = isMobile() ? '360px' : '500px';
        tabContent.style.overflowY = (tabContent.scrollHeight > parseInt(tabContent.style.maxHeight)) ? 'scroll' : 'auto';
      }
    });
  }

  function setInitialButtonText() {
    var buttons = document.querySelectorAll('.show-details');
    buttons.forEach(function(button) {
      var wrapper = button.closest('.top-buttons');
      var panel = wrapper ? wrapper.nextElementSibling : null;
      if (panel && panel.classList.contains('accordion-visible')) {
        button.textContent = isMobile() ? 'Close' : 'Hide Details';
      } else {
        button.textContent = isMobile() ? 'Details' : 'Show Details';
      }
    });
  }

  // ---------------- Events ---------------- //
  function handleCourseListClick(event) {
    var target = event.target;
    var courseItem = target.closest('.course-item');
    if (!courseItem) return;
    if (target.closest('.show-details')) {
      var panel = courseItem.querySelector('.panel');
      var accordionButton = courseItem.querySelector('.accordion');
      var showDetailsButton = courseItem.querySelector('.show-details');
      toggleAccordion(accordionButton, panel, showDetailsButton);
      if (isMobile() && mode !== 'single') toggleModal(courseItem);
    } else if (target.closest('.accordion')) {
      var panel2 = courseItem.querySelector('.panel');
      var accordionButton2 = courseItem.querySelector('.accordion');
      var showDetailsButton2 = courseItem.querySelector('.show-details');
      toggleAccordion(accordionButton2, panel2, showDetailsButton2);
      if (isMobile() && mode !== 'single') toggleModal(courseItem);
    } else if (target.closest('.tablinks')) {
      event.preventDefault();
      var tabLink = target.closest('.tablinks');
      var tabId = tabLink.getAttribute('aria-controls');
      var tabContents = courseItem.querySelectorAll('.tabcontent');
      var tabLinks = courseItem.querySelectorAll('.tablinks');
      tabContents.forEach(function(tab) { tab.style.display = (tab.id === tabId) ? 'block' : 'none'; });
      tabLinks.forEach(function(link) { link.classList.toggle('active', link.getAttribute('aria-controls') === tabId); });
      adjustTabContentHeight();
    }
  }

  function toggleModal(courseItem) {
    var backToTopButton = document.getElementById('BackToTop');
    courseItem.classList.toggle('modal--mg');
    document.body.style.overflow = courseItem.classList.contains('modal--mg') ? 'hidden' : '';
    courseItem.style.zIndex = courseItem.classList.contains('modal--mg') ? '9999' : '';
    if (backToTopButton) {
      backToTopButton.style.zIndex = courseItem.classList.contains('modal--mg') ? '-1' : '';
    }
    if (courseItem.classList.contains('modal--mg')) {
      var tabLinksMobile = courseItem.querySelectorAll('.tab.nodesktop .tablinks');
      var tabContentsMobile = courseItem.querySelectorAll('.tab.nodesktop .tabcontent');
      tabContentsMobile.forEach(function(content){ content.style.display = 'none'; });
      tabLinksMobile.forEach(function(link){ link.classList.remove('active'); });
      if (tabLinksMobile.length > 0 && tabContentsMobile.length > 0) {
        tabLinksMobile[0].classList.add('active');
        tabContentsMobile[0].style.display = 'block';
        adjustTabContentHeight();
      }
    }
  }

  async function handleVariantChange(event) {
    var variantId = event.detail && event.detail.variantId;
    if (!variantId) return;

    var courseJsonUrl = resolveCourseScriptUrl(variantId);
    if (!courseJsonUrl) return;

    try {
      var existingScript = document.getElementById('script-' + variantId) || document.getElementById('script-' + courseJsonUrl);
      if (existingScript) existingScript.remove();

      // reset state
      window.courses = null;
      searchData = [];
      var list = document.getElementById('courseList');
      if (list) list.innerHTML = '';

      // inject new <script>
      var script = document.createElement('script');
      script.src = courseJsonUrl;
      script.id  = 'script-' + (courseJsonUrl.indexOf('/') > -1 ? courseJsonUrl : variantId);
      script.defer = true;
      document.body.appendChild(script);

      // wait for it to load
      await new Promise(function(resolve, reject) {
        script.onload = function() { resolve(); };
        script.onerror = function() { reject(new Error('Failed to load script: ' + courseJsonUrl)); };
      });

      if (Array.isArray(window.courses)) {
        searchData = computeSearchDataFromCourses(window.courses);
        buildResult(searchData);
      } else {
        // try again shortly if courses not yet registered
        setTimeout(function(){ handleVariantChange(event); }, 500);
      }
    } catch (e) {
      console.error(e);
    }
  }

  // ---------------- Initialization ---------------- //
  document.addEventListener('DOMContentLoaded', function() {
    // Initial dataset from the already-included courses_*.js for the selected variant
    if (Array.isArray(window.courses)) {
      searchData = computeSearchDataFromCourses(window.courses);
      buildResult(searchData);
    }

    // variant select → dispatch variantChanged
    var variantSelector = document.querySelector('form[action^="/cart/add"] select[name="id"]');
    if (variantSelector) {
      variantSelector.addEventListener('change', function(e) {
        var vid = e.target.value;
        document.dispatchEvent(new CustomEvent('variantChanged', { detail: { variantId: vid } }));
      });
    }

    // URL param variant
    try {
      var urlParams = new URLSearchParams(window.location.search);
      var urlVariantId = urlParams.get('variant');
      if (urlVariantId) {
        document.dispatchEvent(new CustomEvent('variantChanged', { detail: { variantId: urlVariantId } }));
      }
    } catch (e) {}

    // If no courses loaded yet (non-Combined pages), trigger initial load for current variant
    if (!Array.isArray(window.courses)) {
      var initialId = null;
      try {
        var params2 = new URLSearchParams(window.location.search);
        initialId = params2.get('variant') || (variantSelector && variantSelector.value);
      } catch(e) { initialId = variantSelector && variantSelector.value; }
      if (initialId) {
        document.dispatchEvent(new CustomEvent('variantChanged', { detail: { variantId: initialId } }));
      }
    }

    // Handlers and listeners
    var cl = document.getElementById('courseList');
    if (cl) cl.addEventListener('click', handleCourseListClick);
    window.addEventListener('resize', debounce(setInitialButtonText, 300));
    document.addEventListener('variantChanged', handleVariantChange);

    // Expose loadMoreCourses globally as the button uses inline onclick
    window.loadMoreCourses = loadMoreCourses;
  });
})();
